import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {i18nMixin} from '@aofl/i18n-mixin';
import translations from '../i18n';
import debounce from 'debounce';
import {ApiService} from '../api-service';
import {filterStatuses} from '../constants-enumerate';

const DEFAULT_SEARCH = {
  field: 'name',
  query: ''
};

const DEFAULT_FILTER = {
  status: filterStatuses.ACTIVE,
};

const DEFAULT_SORT = {
  fields: ['name', 'id'],
  direction: 'asc',
  limit: 15,
  is_forward: true
};

/**
 * @summary StudentTeacherFilterDropdown
 * @extends {i18nMixin(AoflElement)}
 */
@customElement('student-teacher-filter-dropdown')
class StudentTeacherFilterDropdown extends i18nMixin(AoflElement) {
  /**
   * Creates an instance of StudentTeacherFilterDropdown.
   */
  constructor() {
    super();

    this.translations = translations;
    this.searchDebounce = debounce(this.search, 200);
  }

  /**
   * @readonly
   */
  static is = 'student-teacher-filter-dropdown';

  @property({type: Boolean})
  disabled = false;

  @property({type: Boolean})
  teacher = false;

  @property({type: Array})
  results = [];

  @property({type: Array})
  selected = [];

  @property({type: Boolean})
  single = false;

  /**
   *
   * @param {Event} e
   */
  searchInputHandler(e) {
    e.stopPropagation();
    this.searchDebounce(e.target.value);
  }

  async search(query = '') {
    const trimQuery = query.trim();
    let search = void 0;

    if (trimQuery.length) {
      search = Object.assign({}, DEFAULT_SEARCH, {query: trimQuery});
    }

    try {
      let data = null;
      if (this.teacher) {
        data = await ApiService.teacherSearch(search, DEFAULT_FILTER, DEFAULT_SORT);
      } else {
        data = await ApiService.studentSearch(search, DEFAULT_FILTER, DEFAULT_SORT);
      }
      this.results = data.results;
    } catch (e) {

    }
  }

  selectHandler(e, item) {
    if (this.selected.indexOf(item.id) === -1) {
      this.dispatchEvent(new CustomEvent('student-teacher-selected', {
        composed: true,
        bubbles: true,
        detail: item
      }));
    }
  }

  connectedCallback() {
    super.connectedCallback();

    this.search();
  }
  /**
   *
   * @return {Object}
   */
  render() {
    return super.render({
      default: {template, styles: [styles]}
    });
  }
}

export default StudentTeacherFilterDropdown;
